import { FC } from 'react';
import { cn } from '@lib/utils.ts';

interface SpinnerProps {
  className?: string;
}
export const Spinner: FC<SpinnerProps> = ({ className }) => {
  return (
    <div
      className={cn(
        'w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin',
        className
      )}
    />
  );
};
